import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Select } from '@cotidia/react-ui'

const mapper = (item) => ({
  value: item.uuid,
  label: item.name,
})

const banner_image = document.querySelector('[data-name="banner_image"] div')
if (banner_image) {
  var banner_image_url = banner_image.style.backgroundImage
}


export default class TabbedSearch extends Component {
  static propTypes = {
    accommodationOptions: PropTypes.arrayOf(PropTypes.shape({
      uuid: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    })).isRequired,
    venuesOptions: PropTypes.arrayOf(PropTypes.shape({
      uuid: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    })).isRequired,
  }

  state = {
    tab: 'accommodation',
    accommodation: '',
    venue: '',
    inputValue :''
  }


  handleSearch = ({ value }) => {
    var typedInSearchText = null;
    console.log('current tab is: ', this.state.tab);
    if (this.state.tab === 'accommodation'){
      typedInSearchText = this.refs.accommodationInput.state.inputValue
    }
    else{
      typedInSearchText = this.refs.venueInput.state.inputValue
    }
    let result = this.props.accommodationOptions.find((item) => item.uuid === value)

    if (! result) {
      result = this.props.venuesOptions.find((item) => item.uuid === value)
    }
    // now we handle the edge case that somebody typed in a result and hit the enter button.
    // when somebody hits the enter button the first selection of the selector gets selected (not necessarily the one
    // that matches the search text in the input field. So when the result label does not contain the characters of
    // the select input text we return the first result that matches input text. If no result matches the input text we
    // do nothing
      if (result) {
          if (!typedInSearchText) {
              // no search text available probably it was a direct mouse click
              location.href = result.url
          }
          else {
              //  some sort of search text is available
              console.log('trying to find ', typedInSearchText, result.name);
              if (result.name.indexOf(typedInSearchText) > -1) {
                  // the result contains the characters of the typed in search text everything seems to be okay
                  location.href = result.url
              }
              else {
                console.log('typed in text did not match result handling fallback!');
                  // the result name does not contain the typed in search text. We return the first result that we find that
                  // contains the typed in search text in its name
                  if (this.state.tab === 'accommodation') {
                      let firstMatchForSearchText = this.props.accommodationOptions.find(function (element) {
                        return element.name.toLowerCase().indexOf(typedInSearchText.toLowerCase()) > -1;
                      });
                      if(firstMatchForSearchText){
                        location.href = firstMatchForSearchText.url
                      }

                  }
                  else {
                      let firstMatchForSearchText = this.props.venuesOptions.find(function (element) {
                          return element.name.toLowerCase().indexOf(typedInSearchText.toLocaleLowerCase()) > -1;
                      });
                      if(firstMatchForSearchText){
                        location.href = firstMatchForSearchText.url
                      }
                  }
              }

          }
    }
  }



  render () {
    const { accommodationOptions, venuesOptions } = this.props
    const { tab } = this.state

    return (
      <div className='tabbed-search'>
        {tab === 'accommodation' && (
          <div className='tabbed-search__body'>
            <form className='form form--search'>
              <div className='form__row'>
                <Select
                  name='value'
                  updateValue={this.handleSearch}
                  options={accommodationOptions.map(mapper)}
                  placeholder="I'm attending"
                  noOptionPlaceholder="Don't see your event? Contact us directly"
                  ref='accommodationInput'
                  value={this.state.inputValue}
                />
              </div>
            </form>
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/EventSearch.js